export enum ThemeName {
  DEFAULT = 'theme-default',
  DARK = 'theme-dark'
}
